








import Component from 'vue-class-component';
import { Page } from '@/layout/mixin/Page';
import ShowPageLayout from '@/common/layout/PageLayout.vue';


@Component({
  components: {
    ShowPageLayout
  }
})
export default class FacilityPage extends Page {
  title: string = 'Obiekt - Informacje o obiekcie';

}
